import type { ILearningCourseRepository } from '@/core/domain/learning/course/ILearningCourseRepository.ts'
import type { IReferentialRepository } from '@/core/domain/referential/IReferentialRepository.ts'
import { NabooContentAxis } from '@/core/domain/nabooContent/NabooContent.ts'
import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus.ts'

export class FetchNabooContentUseCase {
  private readonly learningCourseRepository: ILearningCourseRepository
  private readonly referentialRepository: IReferentialRepository

  constructor(
    learningCourseRepository: ILearningCourseRepository,
    referentialRepository: IReferentialRepository
  ) {
    this.learningCourseRepository = learningCourseRepository
    this.referentialRepository = referentialRepository
  }

  async execute(): Promise<NabooContentAxis[]> {
    const learningCoursesOptions = {
      withModules: true,
      withGrains: true,
      withSupports: false,
      withDomains: true,
      status: [LearningStatus.Values.ACTIVE]
    }

    const referential = await this.referentialRepository.fetchAll()
    const learningCourses =
      await this.learningCourseRepository.fetchAllLearningCourses(learningCoursesOptions)

    return referential
      .map((axis) => {
        const courses = learningCourses.filter((course) =>
          axis.domains.map((domain) => domain.id).includes(course.domain.id)
        )
        return new NabooContentAxis(axis, courses)
      })
      .filter((axis) => axis.learningCourses.length > 0)
  }
}
